// extracted by mini-css-extract-plugin
export var productImage = "_nz-1";
export var viewLink = "_nz-2";
export var wishlistItem = "_nz-0";